import {
  Directive,
  ElementRef,
  Input,
  OnDestroy,
  OnInit,
  Renderer2
} from '@angular/core';
import { Subscription } from 'rxjs';
import { PermissionUiService } from 'src/app/services/authorization/permission-ui.service';

@Directive({
  selector: '[permissionSection]',
  standalone: false
})
export class PermissionOverlayDirective implements OnInit, OnDestroy {

  @Input('permissionSection') sectionId!: string;

  private overlay?: HTMLElement;
  private sub?: Subscription;

  constructor(
    private el: ElementRef,
    private renderer: Renderer2,
    private permissionUi: PermissionUiService
  ) {}

  ngOnInit(): void {
    this.renderer.setStyle(this.el.nativeElement, 'position', 'relative');

    this.sub = this.permissionUi
      .watch(this.sectionId)
      .subscribe(message => {
        message ? this.showOverlay(message) : this.removeOverlay();
      });
  }

  ngOnDestroy(): void {
    this.sub?.unsubscribe();
  }

  private showOverlay(message: string): void {
    if (this.overlay) return;

    this.renderer.addClass(this.el.nativeElement, 'permission-disabled');

    this.overlay = this.renderer.createElement('div');
    this.renderer.addClass(this.overlay, 'permission-overlay');

    this.overlay!.innerHTML = `
      <div class="permission-text">${message}</div>
    `;

    this.renderer.appendChild(this.el.nativeElement, this.overlay);
  }

  private removeOverlay(): void {
    if (!this.overlay) return;

    this.renderer.removeChild(this.el.nativeElement, this.overlay);
    this.renderer.removeClass(this.el.nativeElement, 'permission-disabled');
    this.overlay = undefined;
  }
}
